import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1E88E5", 
      light: "#64B5F6",
      dark: "#1565C0",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#00BCD4", 
      light: "#4DD0E1",
      dark: "#0097A7",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#4CAF50",
      light: "#81C784",
      dark: "#388E3C",
    },
    error: {
      main: "#F44336",
      light: "#E57373",
      dark: "#D32F2F",
    },
    warning: {
      main: "#FF9800",
      light: "#FFB74D",
      dark: "#F57C00",
    },
    info: {
      main: "#9C27B0",
      light: "#cb34e5",
      dark: "#651b72ff",
    },
    text: {
      primary: "#E3F2FD", // آبی بسیار روشن برای متن اصلی
      secondary: "#BBDEFB", // آبی روشن برای متن ثانویه
      disabled: "#546E7A", // خاکستری آبی
    },
    grey: {
      50: "#ECEFF1",
      100: "#CFD8DC",
      200: "#B0BEC5",
      300: "#90A4AE",
      400: "#78909C",
      500: "#607D8B",
      600: "#546E7A",
      700: "#455A64",
      800: "#37474F",
      900: "#263238",
    },
    background: {
      default: "#0A1929", // پس زمینه تاریک آبی
      paper: "#1A2C3D", // زمینه کارت‌ها تاریک آبی
      lightBlue: "#0D2538", // آبی تیره‌تر برای بخش‌های خاص
    },
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
    action: {
      active: "#64B5F6",
      hover: "rgba(100, 181, 246, 0.08)",
      selected: "rgba(100, 181, 246, 0.16)",
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
    },
    divider: "rgba(255, 255, 255, 0.12)",
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      color: "#E3F2FD",
      fontWeight: 600,
    },
    h2: {
      color: "#E3F2FD",
      fontWeight: 600,
    },
    h3: {
      color: "#E3F2FD",
      fontWeight: 600,
    },
    h4: {
      color: "#E3F2FD",
      fontWeight: 600,
    },
    h5: {
      color: "#E3F2FD",
      fontWeight: 500,
    },
    h6: {
      color: "#E3F2FD",
      fontWeight: 500,
    },
    body1: {
      color: "#BBDEFB",
    },
    body2: {
      color: "#90CAF9",
    },
  },
  shape: {
    borderRadius: 8,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 600,
      lg: 900,
      xlg: 1000,
      xl: 1200,
      xxl: 1500,
      exl: 2000,
      tv: 2500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#0A1929",
          color: "#E3F2FD",
        },
        html: {
          fontSize: "12px",
          "@media (min-width:600px)": {
            fontSize: "14px",
          },
          "@media (min-width:1200px)": {
            fontSize: "16px",
          },
          "@media (min-width:1400px)": {
            fontSize: "18px",
          },
        },
        "*": {
          fontFamily: "inherit !important",
        },
      },
    },
  },
});

export default theme;
